module.exports = __webpack_public_path__ + "static/media/FileIcon.d75f5d09.svg";